import React from 'react'
import './index.css';
import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Timeline } from './Timeline';
import { SiMongodb } from "react-icons/si";
import { RiReactjsLine } from "react-icons/ri";
import { SiExpress } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa6";
import { BiLogoTailwindCss } from "react-icons/bi";
import { SiMui } from "react-icons/si";
import { SiExpo } from "react-icons/si";
import { IoLogoHtml5 } from "react-icons/io";
import { FaBootstrap } from "react-icons/fa6";
import { FaJava } from "react-icons/fa6";

export const About = () => {

  const controls = useAnimation();
  useEffect(() => {
    controls.start({ opacity: 1, x: 0 });
  }, [controls]);

  return (
    <motion.div className='About'
      initial={{ opacity: 0, x: -20 }}
      animate={controls}
      transition={{ duration: 1 }}
    >
      <div className="Header">
        About Me
      </div>
      <div className="Sumamry">
        I am a seasoned full-stack developer with a strong proficiency in React JS and React Native, backed by a solid foundation in Node JS for backend development. My expertise extends to working with databases, including MySQL and MongoDB. I hold a B.Tech degree from Calcutta Institute of Engineering, showcasing my strong educational background.
        <br />
        Currently, I am leveraging my skills as an Associate Systems Engineer at IBM, where I contribute to the development and maintenance of robust software systems. My journey in the tech industry began as a Software Programmer Trainee at MSQube, where I gained valuable hands-on experience and honed my programming skills.
        <br />
        Beyond my technical pursuits, I have a deep passion for painting, which adds a creative dimension to my profile. I believe in the synergy of technology and art, and I am always eager to explore new opportunities that allow me to merge my technical expertise with my artistic inclinations.
        <br />
        In addition to my role at IBM, I also work as an independent freelancer on weekends, taking on diverse projects that allow me to continually expand my skill set and contribute to a variety of exciting ventures.
        <br />
        Here are some of the Tech Stacks I have Worked with.
      </div>
      <div className="TechStacks">
        <SiMongodb style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <RiReactjsLine style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <SiExpress style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <FaNodeJs style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <BiLogoTailwindCss style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <SiMui style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <SiExpo style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <IoLogoHtml5 style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <FaBootstrap style={{
          fontSize: '30px',
          width: '75px'
        }} />
        <FaJava style={{
          fontSize: '30px',
          width: '75px'
        }} />
      </div>
      <div className="Timeline">
        <Timeline />
      </div>
    </motion.div>
  )
}
